import { EVENT_AWARD_TYPE, EVENT_OTYPE } from '@/constants/awards'
import { ENTITY_TYPE } from '@/constants/entities'
import { INITIATIVE_EVENT_TYPE } from '@/constants/initiative'

/**
 * This function returns the award context for events
 * @param event
 * @param type - goal | initiative
 * @param contextTitle
 * @returns {}
 */
export default (event, type, contextTitle) => {
  const context = {
    contextType: type === ENTITY_TYPE.GOAL ? EVENT_OTYPE.GOAL_EVENT : EVENT_OTYPE.INITIATIVE_EVENT,
    contextId: event.id,
    contextTitle,
    goalId: event.goalId,
    orgId: event.organizationId,
    recipientIds: [event.actorId]
  }
  if (event.type === INITIATIVE_EVENT_TYPE.FIELD_CHANGED) {
    context.type = EVENT_AWARD_TYPE.initiative[`${event.type}-${event.field}`]
  } else {
    context.type = EVENT_AWARD_TYPE[type][event.type]
  }
  return context
}
